import { createStore } from "vuex";
import customer from "@/apps/merchant3/store/customer/customer.module";
import clerk from "@/apps/merchant3/store/clerk/clerk.module";
import PersonRegistrationModule from "@/apps/person-registration/store/personRegistration.module";
import CreditLineModule from "@/apps/credit-line/store/creditLine.module";
import CoreAppOnboardingModule from "@/apps/core-app-onboarding/store/core-app-onboarding.module";
import PersonModule from "@/apps/merchant3/store/person/person.module";
import carts from "@/apps/merchant3/store/carts/carts.module";
import dashboard from "@/apps/dashboard/store/dashboard.module";
import merchant from "@/apps/merchant3/store/merchant/merchant.module";
import payments from "@/apps/merchant3/store/payments/payment.module";
import offers from "@/apps/merchant3/store/offers/offers.module";
import RepairsModule from "@/apps/merchant3/store/repair/repair.module";
import { IVuexState } from "@/shared-models/IVuex";
import ui from "@/apps/merchant3/store/ui/ui.module";
import sale from "@/apps/merchant3/store/sale/sale.module";
import configurations from "@/apps/merchant3/store/configurations/configurations.module";
import offersV2 from "@/apps/merchant3/store/offersv2/offers.module";

export const store = createStore<IVuexState>({
  strict: false,
  modules: {
    configurations: configurations,
    person: PersonModule,
    personRegistration: PersonRegistrationModule,
    creditLine: CreditLineModule,
    coreAppOnboarding: CoreAppOnboardingModule,
    repair: RepairsModule,
    customer,
    clerk,
    dashboard,
    merchant,
    carts,
    offers,
    payments,
    ui,
    sale,
    offersV2,
  },
});
